var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentPath !== _vm.resolvedPath)?_c('router-link',_vm._b({},'router-link',_vm.$attrs,false),[_vm._t("default")],2):_c('a',{attrs:{"href":_vm.resolvedObject.href}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }